






























































































































































import {
  Vue,
  Component,
  Prop,
  Watch,
} from "@/shared/vuepack";
import EmployerMigrationPeriodForm from "@/admin/components/employer-management/EmployerMigrationPeriodForm.vue";
import {
  BankCustodian,
  EmployerDrivewealthListRequest,
  Employer,
  PartnerEmployerInstrumentList,
  InstrumentList, UpdateEmployerAgreementRequest
} from "@/admin/types";
import {
  AgreementCategory,
  DrivewealthAccountManagementType,
  FeatureFlags,
  UserPermission
} from "@/shared/types";
import VueRouter, { Location } from "vue-router";
import { Validator, Field } from "vee-validate";
import { useInstrumentListStore } from "@/admin/store/instrumentList";
import { useCustodianSettingsStore } from "@/shared/store/custodianSettings";
import { useEmployerStore } from "@/admin/store/employer";
import {
  InstrumentList as InstrumentListRoute,
  RolePermissions
} from "@/admin/route-names";
import { useFeatureFlagStore } from "@/shared/store/featureFlag";
import { useRolePermissionsStore } from "@/shared/store/rolePermissions";
import { useSigningDocumentStore } from "@/admin/store/signingDocument";
import { useNotifierStore } from "@/shared/store/notifier";

const fallbackAdvisoryDefaultId = 1;
const fallbackOpenBrokerageDefaultId = 2;

@Component({
  components: {
    EmployerMigrationPeriodForm,
  }
})
export default class DrivewealthOptions extends Vue {
  $router: VueRouter;
  $validator: Validator;

  instrumentListStore = useInstrumentListStore();
  custodianSettingsStore = useCustodianSettingsStore();
  employerStore = useEmployerStore();
  featureFlagStore = useFeatureFlagStore();
  signingDocumentStore = useSigningDocumentStore();
  notifierStore = useNotifierStore();
  rolePermissions = useRolePermissionsStore();
  @Prop() employerId: string;

  hasAdvisory: boolean = null;
  hasRiaManaged: boolean = null;
  hasSelfDirected: boolean = null;
  isCuratedRtqEnabled: boolean = null;
  allowPreEnrollment = false;
  pendingEnrollmentCount = 0;
  draftCuratedRtqEnabled = false;
  partnerHasCuratedRtqEnabled = false;
  disableRtqCheckbox = false;
  isLoaded = false;
  managedAgreementListId = "0";
  advisoryAgreementListId = "0";
  openBrokerageAgreementListId = "0";
  custodianManagedAgreementListId = "0";
  custodianAdvisoryAgreementListId = "0";
  custodianOpenBrokerageAgreementListId = "0";
  employerManagedAgreementListId = "0";
  employerAdvisoryAgreementListId = "0";
  employerOpenBrokerageAgreementListId = "0";
  submitManagedAgreementDisabled = false;
  submitAdvisoryAgreementDisabled = false;
  submitOpenBrokerageAgreementDisabled = false;

  // form values
  advisoryDefaultInstrumentListId = fallbackAdvisoryDefaultId;
  openBrokerageDefaultInstrumentListId = fallbackOpenBrokerageDefaultId;

  get hasEditPermission (): boolean {
    return this.featureFlagStore.flags.hsa4475allowRolePermissions
      ? this.rolePermissions.userHasAdminPermission(UserPermission.AdminPortalEmployerEdit)
      : true;
  }

  formatDisplayName (instrument: InstrumentList) {
    return `${instrument.listName}${(instrument.isDefault ? " (Custodian Default) " : "")}`;
  }

  // defaults from API call
  preselectedAdvisoryDefault = 0;
  preselectedOpenBrokerageDefault = 0;

  created () {
    this.employerStore.loadEmployer(Number(this.employerId));
    this.employerStore.loadEmployerInvestmentType(Number(this.employerId))
      .then(result => {
        if (result) {
          this.loadInvestmentTypes(result);
        }
      });
    this.instrumentListStore.loadInstrumentLists();
    this.loadEmployerDefaultList();
    this.signingDocumentStore.loadAllAdmin();
  }

  get employer (): Employer {
    const loadedEmployer = this.employerStore.employerDetail(this.employerId);
    return loadedEmployer.employer;
  }

  get submitAdvisoryDisabled (): boolean {
    const listSelectionChanged = this.advisoryDefaultInstrumentListId !== this.preselectedAdvisoryDefault;
    const curatedRtqChanged = this.isCuratedRtqEnabled !== this.draftCuratedRtqEnabled;
    return !curatedRtqChanged && !listSelectionChanged;
  }

  get submitOpenBrokerageDisabled (): boolean {
    return this.openBrokerageDefaultInstrumentListId === this.preselectedOpenBrokerageDefault;
  }

  get displayMigrationForm (): boolean {
    return this.custodianSettingsStore.employerCustodian === BankCustodian.HsaBank;
  }

  get isAdvisoryInstrumentListDisabled () {
    return this.draftCuratedRtqEnabled;
  }

  @Watch("employerStore.investmentEnrollmentType", { deep: true })
  loadInvestmentTypes (v) {
    if (v[this.employerId].allowedEmployerInvestmentAccountTypes) {
      this.hasAdvisory = v[this.employerId].allowedEmployerInvestmentAccountTypes.hasAdvisory;
      this.hasRiaManaged = v[this.employerId].allowedEmployerInvestmentAccountTypes.hasRiaManaged;
      this.hasSelfDirected = v[this.employerId].allowedEmployerInvestmentAccountTypes.hasSelfDirected;
      this.allowPreEnrollment = v[this.employerId].allowedEmployerInvestmentAccountTypes.allowPreEnrollment;
      this.pendingEnrollmentCount = v[this.employerId].allowedEmployerInvestmentAccountTypes.pendingEnrollmentCount;
      this.isCuratedRtqEnabled = v[this.employerId].allowedEmployerInvestmentAccountTypes.isCuratedRtqEnabled;
      this.partnerHasCuratedRtqEnabled = v[this.employerId].allowedEmployerInvestmentAccountTypes.partnerHasCuratedRtqEnabled;

      if (this.isCuratedRtqEnabled !== null) {
        this.draftCuratedRtqEnabled = this.isCuratedRtqEnabled;
      }
      else {
        this.draftCuratedRtqEnabled = this.partnerHasCuratedRtqEnabled;
      }
    }
  }

  @Watch("custodianSettingsStore.employerCustodian")
  updateCuratedRtq (): void {
    this.disableRtqCheckbox = this.custodianSettingsStore.employerCustodian !== BankCustodian.HsaBank;
  }

  loadEmployerDefaultList (): void {
    const custodianId = this.mapBankCustodianToId(this.custodianSettingsStore.employerCustodian);
    if (custodianId) {
      this.instrumentListStore.loadCustodianDefaultInstrumentList(custodianId);
      this.signingDocumentStore.getCustodianDefaultAgreement(Number(custodianId))
          .then(() => {
            const agreements = this.signingDocumentStore.custodianDefaultAgreements;
            if (agreements.length !== 0) {
              const managedAgreement = agreements.filter(x => x.accountType === DrivewealthAccountManagementType.RiaManaged);
              this.custodianManagedAgreementListId = managedAgreement.length !== 0 ? managedAgreement[0].documentKey : "0";

              const advisoryAgreement = agreements.filter(x => x.accountType === DrivewealthAccountManagementType.Advisory);
              this.custodianAdvisoryAgreementListId = advisoryAgreement.length !== 0 ? advisoryAgreement[0].documentKey : "0";

              const openBrokerageAgreement = agreements.filter(x => x.accountType === DrivewealthAccountManagementType.OpenBrokerage);
              this.custodianOpenBrokerageAgreementListId = openBrokerageAgreement.length !== 0 ? openBrokerageAgreement[0].documentKey : "0";
            } else {
              this.custodianManagedAgreementListId = "0";
              this.custodianAdvisoryAgreementListId = "0";
              this.custodianOpenBrokerageAgreementListId = "0";
            }
          })
          .then(() => {
            this.signingDocumentStore.getEmployerAgreement(Number(this.employerId))
                .then(() => {
                  const agreements = this.signingDocumentStore.employerAgreements;
                  if (agreements.length !== 0) {
                    const managedAgreement = agreements.filter(x => x.accountType === DrivewealthAccountManagementType.RiaManaged);
                    this.employerManagedAgreementListId = managedAgreement.length !== 0 && managedAgreement[0].documentKey ? managedAgreement[0].documentKey : "0";

                    const advisoryAgreement = agreements.filter(x => x.accountType === DrivewealthAccountManagementType.Advisory);
                    this.employerAdvisoryAgreementListId = advisoryAgreement.length !== 0 && advisoryAgreement[0].documentKey ? advisoryAgreement[0].documentKey : "0";

                    const openBrokerageAgreement = agreements.filter(x => x.accountType === DrivewealthAccountManagementType.OpenBrokerage);
                    this.employerOpenBrokerageAgreementListId = openBrokerageAgreement.length !== 0  && openBrokerageAgreement[0].documentKey ? openBrokerageAgreement[0].documentKey : "0";
                  } else {
                    this.employerManagedAgreementListId = "0";
                    this.employerAdvisoryAgreementListId = "0";
                    this.employerOpenBrokerageAgreementListId = "0";
                  }

                  this.managedAgreementListId = this.employerManagedAgreementListId !== "0" ? this.employerManagedAgreementListId : this.custodianManagedAgreementListId;
                  this.advisoryAgreementListId = this.employerAdvisoryAgreementListId !== "0" ? this.employerAdvisoryAgreementListId : this.custodianAdvisoryAgreementListId;
                  this.openBrokerageAgreementListId = this.employerOpenBrokerageAgreementListId !== "0" ? this.employerOpenBrokerageAgreementListId : this.custodianOpenBrokerageAgreementListId;
                });
          });
    }
    const loadedEmployer = this.employerStore.employerDetail(this.employerId);
    if (loadedEmployer.loaded) {
      this.instrumentListStore.loadPartnerInstrumentList(loadedEmployer.employer.partner.id)
          .then(() =>
              this.instrumentListStore.loadEmployerDefaultInstrumentList(Number(this.employerId))
                  .then(() => {
                    if (this.instrumentListStore.advisoryEmployerDefaultInstrumentList) {
                      this.advisoryDefaultInstrumentListId
                          = this.instrumentListStore.advisoryEmployerDefaultInstrumentList.listId;
                    } else if (this.instrumentListStore.partnerInstrumentList &&
                        this.instrumentListStore.partnerInstrumentList.partnerAdvisoryListId) {
                      this.advisoryDefaultInstrumentListId = this.instrumentListStore.partnerInstrumentList.partnerAdvisoryListId;
                    } else {
                      this.advisoryDefaultInstrumentListId = this.instrumentListStore.advisoryCustodianDefaultInstrumentList ?
                          this.instrumentListStore.advisoryCustodianDefaultInstrumentList.listId : fallbackAdvisoryDefaultId;
                    }

                    if (this.instrumentListStore.openBrokerageEmployerDefaultInstrumentList) {
                      this.openBrokerageDefaultInstrumentListId
                          = this.instrumentListStore.openBrokerageEmployerDefaultInstrumentList.listId;
                    } else if (this.instrumentListStore.partnerInstrumentList &&
                        this.instrumentListStore.partnerInstrumentList.partnerOpenBrokerageListId) {
                      this.openBrokerageDefaultInstrumentListId
                          = this.instrumentListStore.partnerInstrumentList.partnerOpenBrokerageListId;
                    } else {
                      this.openBrokerageDefaultInstrumentListId
                          = this.instrumentListStore.openBrokerageCustodianDefaultInstrumentList ?
                          this.instrumentListStore.openBrokerageCustodianDefaultInstrumentList.listId
                          : fallbackOpenBrokerageDefaultId;
                    }

                    this.preselectedAdvisoryDefault = this.advisoryDefaultInstrumentListId;
                    this.preselectedOpenBrokerageDefault = this.openBrokerageDefaultInstrumentListId;
                  })
                  .finally(() => {
                    this.isLoaded = true;
                  }));
    }
  }

  mapBankCustodianToId (custodian: BankCustodian): number {
    const custodianIdMap = {
      umb: 1,
      elements: 2,
      ucb: 3,
      avidia: 4,
      allegacy: 5,
      hsaBank: 6,
      omnibus: 7
    };

    return custodianIdMap[custodian];
  }

  saveAdvisoryList (): void {
    if (this.submitAdvisoryDisabled) {
      return;
    }

    const request: EmployerDrivewealthListRequest = {
      employerId: Number(this.employerId),
      instrumentListId: this.advisoryDefaultInstrumentListId,
      investmentOption: DrivewealthAccountManagementType.Advisory
    };
    this.instrumentListStore.saveEmployerDefaultList(request)
      .finally(() => this.preselectedAdvisoryDefault = this.advisoryDefaultInstrumentListId);

    this.saveInvestmentType();
  }

  saveInvestmentType (): void {
    this.employerStore.setEmployerInvestmentType({
      employerId: Number(this.employerId), investmentType: {
        hasAdvisory: this.hasAdvisory,
        hasRiaManaged: this.hasRiaManaged,
        hasSelfDirected: this.hasSelfDirected,
        allowPreEnrollment: this.allowPreEnrollment,
        isCuratedRtqEnabled: this.draftCuratedRtqEnabled
      }
    }).finally(() => this.isCuratedRtqEnabled = this.draftCuratedRtqEnabled);
  }

  saveOpenBrokerageList () {
    if (this.submitOpenBrokerageDisabled) {
      return;
    }

    const request: EmployerDrivewealthListRequest = {
      employerId: Number(this.employerId),
      instrumentListId: this.openBrokerageDefaultInstrumentListId,
      investmentOption: DrivewealthAccountManagementType.OpenBrokerage
    };
    this.instrumentListStore.saveEmployerDefaultList(request)
      .finally(() => this.preselectedOpenBrokerageDefault = this.openBrokerageDefaultInstrumentListId);
  }

  get defaultAgreementOptions () {
    const agreements = this.signingDocumentStore.documentsAdmin
        .filter(x => x.agreementCategory === AgreementCategory.Investment)
        .map(x => {
          return { value: x.documentKey, text: x.name };
        });
    agreements.unshift({ value: "0", text: "Select Default Agreement" });
    return agreements;
  }

  saveManagedDefault () {
    if (this.submitManagedAgreementDisabled) {
      return;
    }

    if (this.managedAgreementListId === "0") {
      this.errors.add({field: "managed-agreement", msg: "Please select default agreement"});
      return;
    }

    let agreementId = this.managedAgreementListId;

    if (this.custodianManagedAgreementListId === this.managedAgreementListId) {
      if (this.employerManagedAgreementListId !== "0" && this.employerManagedAgreementListId !== this.managedAgreementListId) {
        agreementId = null;
      } else {
        return;
      }
    }

    this.submitManagedAgreementDisabled = true;

    const request: UpdateEmployerAgreementRequest = {
      employerId: Number(this.employerId),
      accountType: DrivewealthAccountManagementType.RiaManaged,
      documentKey: agreementId
    };

    this.signingDocumentStore.saveEmployerAgreement(request)
        .finally(() => {
          this.submitManagedAgreementDisabled = false;
          this.employerManagedAgreementListId = agreementId ? agreementId : "0";
          this.managedAgreementListId = agreementId ? agreementId : this.custodianManagedAgreementListId;
        });
  }

  saveAdvisoryDefault () {
    if (this.submitAdvisoryAgreementDisabled) {
      return;
    }

    if (this.advisoryAgreementListId === "0") {
      this.errors.add({field: "advisory-agreement", msg: "Please select default agreement"});
      return;
    }

    let agreementId = this.advisoryAgreementListId;

    if (this.custodianAdvisoryAgreementListId === this.advisoryAgreementListId) {
      if (this.employerAdvisoryAgreementListId !== "0" && this.employerAdvisoryAgreementListId !== this.advisoryAgreementListId) {
        agreementId = null;
      } else {
        return;
      }
    }

    this.submitAdvisoryAgreementDisabled = true;

    const request: UpdateEmployerAgreementRequest = {
      employerId: Number(this.employerId),
      accountType: DrivewealthAccountManagementType.Advisory,
      documentKey: agreementId
    };

    this.signingDocumentStore.saveEmployerAgreement(request)
        .finally(() => {
          this.submitAdvisoryAgreementDisabled = false;
          this.employerAdvisoryAgreementListId = agreementId ? agreementId : "0";
          this.advisoryAgreementListId = agreementId ? agreementId : this.custodianAdvisoryAgreementListId;
        });
  }

  saveOpenBrokerageDefault () {
    if (this.submitOpenBrokerageAgreementDisabled) {
      return;
    }

    if (this.openBrokerageAgreementListId === "0") {
      this.errors.add({field: "open-brokerage-agreement", msg: "Please select default agreement"});
      return;
    }

    let agreementId = this.openBrokerageAgreementListId;

    if (this.custodianOpenBrokerageAgreementListId === this.openBrokerageAgreementListId) {
      if (this.employerOpenBrokerageAgreementListId !== "0" && this.employerOpenBrokerageAgreementListId !== this.openBrokerageAgreementListId) {
        agreementId = null;
      } else {
        return;
      }
    }

    this.submitOpenBrokerageAgreementDisabled = true;

    const request: UpdateEmployerAgreementRequest = {
      employerId: Number(this.employerId),
      accountType: DrivewealthAccountManagementType.OpenBrokerage,
      documentKey: agreementId
    };

    this.signingDocumentStore.saveEmployerAgreement(request)
        .finally(() => {
          this.submitOpenBrokerageAgreementDisabled = false;
          this.employerOpenBrokerageAgreementListId = agreementId ? agreementId : "0";
          this.openBrokerageAgreementListId = agreementId ? agreementId : this.custodianOpenBrokerageAgreementListId;
        });
  }

  @Watch("employerStore.employers", { deep: true })
  fetchInstrumentListsEmployerChange () {
    this.loadEmployerDefaultList();
  }
}
